import JSONApiService from "@/services/JSONApiService";
import { EVENT_MODEL } from "@/models/event-model";
import { SUMMARY_MODEL } from "@/models/summary-model";
import { include, CAUSER, USER, BOOKING } from "@/models/relationships";
import { MATCH_MODEL } from "@/models/match-model";
import { USER_MODEL } from "@/models/user-model";

export default ({ commit } = {}) => ({
  getAllSummaries: async params =>
    JSONApiService(commit)
      .all(SUMMARY_MODEL)
      .get(params),
  getEvents: async filters =>
    JSONApiService(commit)
      .all(EVENT_MODEL)
      .get({ ...filters, ...include(CAUSER) }),
  getMatches: async id =>
    JSONApiService(commit)
      .one(USER_MODEL, id)
      .all(MATCH_MODEL)
      .get(include(USER, BOOKING)),
  updateMatch: async ({ matchId, data }) =>
    JSONApiService(commit)
      .one(MATCH_MODEL, matchId)
      .patch(data)
});
